import { render, staticRenderFns } from "./CkFooter.vue?vue&type=template&id=698c5b24&scoped=true&"
import script from "./CkFooter.vue?vue&type=script&lang=js&"
export * from "./CkFooter.vue?vue&type=script&lang=js&"
import style0 from "./CkFooter.vue?vue&type=style&index=0&id=698c5b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698c5b24",
  null
  
)

export default component.exports